export default {"src":"/_next/static/image/public/images/ic-guest_managepayment.f6ea29fdc2c7067376ea751b2db5eaaa.svg","height":150,"width":142};